module.exports = __webpack_public_path__ + "fonts/Montserrat-MediumItalic.97573fc8.ttf";